module.exports = __webpack_public_path__ + "static/media/tracker.5f72db3d.png";